import { DeviceHealthRecordType } from "../enums/device-health-record-type";

export class DeviceHealthRecordHelper {
    static isTelematic(type: DeviceHealthRecordType): boolean {
        return [
            DeviceHealthRecordType.BadSatFix,
            DeviceHealthRecordType.MessageSpam,
            DeviceHealthRecordType.MissingOdometer,
            DeviceHealthRecordType.LocationSnapped
        ].includes(type);
    }

    static isCamera(type: DeviceHealthRecordType): boolean {
        return [
            DeviceHealthRecordType.CameraVideoLoss,
            DeviceHealthRecordType.CameraMemoryFault,
            DeviceHealthRecordType.CameraStorageFailure,
            DeviceHealthRecordType.CameraPowerLoss,
            DeviceHealthRecordType.CameraGPSLoss
        ].includes(type)
    }
}